import type { ReactNode } from "react";
import PublicHeader from "../../components/PublicHeader";
import PublicFooter from "../../components/PublicFooter";
import { Eyebrow, Fleuron } from "../../components/design";

export function LegalLayout({
  eyebrow,
  title,
  updated,
  children,
}: {
  eyebrow: string;
  title: ReactNode;
  updated: string;
  children: ReactNode;
}) {
  return (
    <div className="paper-bg" style={{ minHeight: "100vh" }}>
      <PublicHeader />
      <main
        style={{
          maxWidth: 760,
          margin: "0 auto",
          padding: "44px 22px 60px",
          fontFamily: "var(--f-body)",
          color: "var(--ink)",
        }}
      >
        <div>
          <Eyebrow>{eyebrow}</Eyebrow>
          <h1
            style={{
              fontFamily: "var(--f-display)",
              fontWeight: 400,
              fontSize: 38,
              lineHeight: 1.05,
              letterSpacing: "-0.02em",
              margin: "0 0 8px",
              color: "var(--ink)",
            }}
          >
            {title}
          </h1>
          <Fleuron style={{ margin: "16px 0 22px" }} />
          <p
            style={{
              fontFamily: "var(--f-body)",
              fontStyle: "italic",
              fontSize: 14,
              color: "var(--ink-faint)",
              margin: "0 0 28px",
            }}
          >
            Stand: {updated}
          </p>
          <div className="legal-content">{children}</div>
        </div>
      </main>
      <PublicFooter />
      <style>{`
        .legal-content { font-family: var(--f-body); font-size: 17px; line-height: 1.55; color: var(--ink); }
        .legal-content h2 { font-family: var(--f-display); font-style: italic; font-weight: 400; font-size: 26px; line-height: 1.15; letter-spacing: -0.015em; margin: 32px 0 12px; color: var(--ink); }
        .legal-content h3 { font-family: var(--f-display); font-weight: 500; font-style: normal; font-size: 19px; line-height: 1.2; margin: 24px 0 8px; color: var(--ink); }
        .legal-content p { margin: 0 0 14px; color: var(--ink-soft); }
        .legal-content ul, .legal-content ol { margin: 0 0 16px; padding-left: 22px; color: var(--ink-soft); }
        .legal-content li { margin-bottom: 6px; }
        .legal-content strong { color: var(--ink); font-weight: 600; }
        .legal-content a { color: var(--oxblood); }
        .legal-content table { width: 100%; border-collapse: collapse; margin: 12px 0 22px; font-size: 15px; }
        .legal-content th, .legal-content td { text-align: left; padding: 10px 12px; border-bottom: 1px solid rgba(43,26,15,0.10); vertical-align: top; }
        .legal-content th { font-family: var(--f-ui); font-size: 12px; text-transform: uppercase; letter-spacing: 0.12em; color: var(--ink-faint); font-weight: 600; background: var(--paper-50); }
        .legal-content code { background: var(--paper-200); padding: 1px 6px; border-radius: 4px; font-size: 14px; }
      `}</style>
    </div>
  );
}
